import { PaintedScene } from '../PaintedScene';

export const ICE_CAVE_WANDER_PHASER_KEY = 'IceCaveWanderScene' as const;
export const ICE_CAVE_WANDER_MANIFEST_KEY = 's-310-ice-cave' as const;

export class IceCaveWanderScene extends PaintedScene {
  constructor() {
    super(ICE_CAVE_WANDER_PHASER_KEY, ICE_CAVE_WANDER_MANIFEST_KEY);
  }
}
